import request from '@/utils/request' //引入封装好的 axios 请求
//企业填报信息列表
export function enterList(data = {}) {
    return request({
        url: '/api/v1/companyInfo/selectCompanyList',
        method: 'post',
        data: data
    })
}
//入住金融机构信息列表
export function checkinList(data = {}) {
    return request({
        url: '/api/v1/financial/selectListWithPage',
        method: 'post',
        data: data
    })
}
//操作日志信息列表
export function operaLogList(data = {}) {
    return request({
        url: '/api/v1/loginLog/selectTrailLogList',
        method: 'post',
        data: data
    })
}
//登录日志
export function loginList(data = {}) {
    return request({
        url: '/api/v1/loginLog/selectLoinLogList',
        method: 'post',
        data: data
    })
}
// 信易贷报送明细
export function xydDetailList(data = {}) {
    return request({
        url: '/api/v1/loanInfo/selectLoanInfoList',
        method: 'post',
        data: data
    })
}

//用户列表
export function userInfoList(data = {}) {
    return request({
        url: '/api/v1/userInfo/user_info_list',
        method: 'get',
        params: data
    })
}
//用户删除
export function deleteUser(data = {}) {
    return request({
        url: '/api/v1/userInfo/delete',
        method: 'get',
        params: data
    })
}
//用户修改

export function modUser(data = {}) {
    return request({
        url: '/api/v1/user/mod',
        method: 'post',
        data: data
    })
}
// 企业管理
export function enterMangeList(data = {}) {
    return request({
        url: '/api/v1/cor/list',
        method: 'post',
        data: data
    })
}
// 企业管理详情
export function enterMangeDetail(data = {}) {
    return request({
        url: '/api/v1/cor/detail',
        method: 'get',
        params: data
    })
}